import axios from "../http";

class WMS {
  postWMSOrderExcel(data) {
    const url = "/oa/api/upload/order";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 订单错误记录 */
  getOrderErrRecordList() {
    const url = "/oa/api/order/get/order/failure";
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 重新导入 */
  postWmsReimport() {
    const url = "/oa/api/order/import/order/failure";
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default WMS;
